<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Proposte Gestione</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Proposte Gestione</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
</div>


<div class="content-block">



  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Elenco proposte di gestione
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">

        <div class="row" style="padding:10px 0">
          <div class="col-4">
            Solo Non Visti <dx-check-box [(value)]="filterNonVisti" (onValueChanged)="onFilterNonVistiChanged()"></dx-check-box>
          </div>
          <div class="col-4">
            <dx-button
              stylingMode="contained"
              text="Segna come visti"
              type="normal"
              width="120"
              (onClick)="onBtnSegnaVistiClick()">
            </dx-button>
          </div>
        </div>

        <dx-data-grid
          #grid
          [dataSource]="dataSource"
          keyExpr="id"
          [showBorders]="true"
          [focusedRowEnabled]="false"
          [columnAutoWidth]="true"
          [showColumnLines]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          >

          <dxo-editing
            mode="row"
            [allowAdding]="false"
            [allowUpdating]="false"
            [allowDeleting] ="false"
            [selectTextOnEditStart]="true"
            [useIcons]="true"
            >
            <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
          </dxo-editing>

          <dxo-paging [pageSize]="25"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-selection mode="multiple"></dxo-selection>

          <dxi-column
            dataField="id"
            [visible]="false"
            [allowEditing]="false">
          </dxi-column>

          <dxi-column
            [allowFiltering]="false"
            [allowSorting]="false" cellTemplate="templateProposta"
            width="35"
            caption="">
          </dxi-column>

          <dxi-column
            name="listTipoProposta"
            caption="Tipo Proposta"
            dataField="tipo">
            <dxo-lookup [dataSource]="listTipoProposta" valueExpr="codice" displayExpr="descrizione"></dxo-lookup>
          </dxi-column>

          <dxi-column
            name="data"
            dataField="dataRif"
            caption="Data Proposta"
            format="dd/MM/yyyy"
            dataType="date">
          </dxi-column>

          <dxi-column
            name="visto"
            dataField="visto"
            caption="Visto"
            [visible]="!filterNonVisti"
            dataType="boolean">
          </dxi-column>

          <dxi-column
            name="qta"
            dataField="qta"
            caption="Quantità"
            dataType="number">
          </dxi-column>

          <dxi-column
            name="dipendente"
            caption="Dipendente"
            dataField="idDipendente">
            <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" [displayExpr]="getDipendenteDisplayExpr"></dxo-lookup>
          </dxi-column>

          <dxi-column
            name="tipoArticolo"
            caption="Tipo Articolo"
            dataField="idTipoArticolo">
            <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
          </dxi-column>

          <dxi-column
            name="articolo"
            caption="Articolo"
            dataField="idArticolo">
            <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
          </dxi-column>

          <dxi-column
            name="dettagli"
            dataField="dettagli">
          </dxi-column>



          <div *dxTemplate="let d of 'templateProposta'">
            @if (d.data.tipo === 'R') {
              <button class="icon-button" (click)="doConfermaRitiro(d.data)">
                <img
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Conferma ritiro"
                  alt="Conferma ritiro"
                  class="grid-icon"
                  src="assets/icons/ritiro.png"
                  />
                </button>
              }
              @if (d.data.tipo === 'P') {
                <button class="icon-button" (click)="doAggiornaModello(d.data)">
                  <img
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Aggiorna articoli previsti"
                    alt="Aggiorna articoli previsti"
                    class="grid-icon"
                    src="assets/icons/tshirt.png"
                    />
                  </button>
                }
                @if (d.data.tipo === 'C') {
                  <button class="icon-button" (click)="doConsegnaArticolo(d.data)">
                    <img
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Vai a consegna articolo"
                      alt="Vai a consegna articolo"
                      class="grid-icon"
                      src="assets/icons/consegna.png"
                      />
                    </button>
                  }
                  @if (d.data.tipo === 'N') {
                    <button class="icon-button" (click)="doCompletaNuovoArticolo(d.data)">
                      <img
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completa dati nuovo articolo"
                        alt="Completa dati nuovo articolo"
                        class="grid-icon"
                        src="assets/icons/fillform.png"
                        />
                      </button>
                    }
                    @if (d.data.tipo === 'O') {
                      <button class="icon-button" (click)="doSostituisciArticoloObsoleto(d.data)">
                        <img
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Sostituisci articolo obsoleto"
                          alt="Sostituisci articolo obsoleto"
                          class="grid-icon"
                          src="assets/icons/change.png"
                          />
                        </button>
                      }
                      @if (d.data.tipo === 'O') {
                        <button class="icon-button" (click)="doMarcaObsoletoFatto(d.data)">
                          <img
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Segna come fatto"
                            alt="Segna come fatto"
                            class="grid-icon"
                            src="assets/icons/markdone.png"
                            />
                          </button>
                        }
                        @if (d.data.tipo === 'D' && d.data.idDipendente > 0) {
                          <button class="icon-button" (click)="doVerificaDatiDipendente(d.data)">
                            <img
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Verifica dati dipendente"
                              alt="Verifica dati dipendente"
                              class="grid-icon"
                              src="assets/icons/fillform.png"
                              />
                            </button>
                          }

                        </div>

                      </dx-data-grid>
                    </div><!-- /.card-body -->
                  </div>
                  <!-- /.card -->

                </section>

              </div>

              <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
                [(visible)]="loadPanelVisible"
                [showIndicator]="true"
                [showPane]="true"
                [shading]="true"
                [hideOnOutsideClick]="false">
              </dx-load-panel>

              @if (showPopupSostituisciArticolo) {
                <app-popup-sostituisci-articolo
                  (popupSostituisciArticoloEventEmitter)="onPopupSostituisciArticoloEvent($event)"
                  [idArticolo]="idArticoloDaSostituire">
                </app-popup-sostituisci-articolo>
              }